<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.88836 2.88836C1.66797 4.10874 1.66797 6.07293 1.66797 10.0013C1.66797 13.9296 1.66797 15.8939 2.88836 17.1142C4.10874 18.3346 6.07293 18.3346 10.0013 18.3346C13.9296 18.3346 15.8939 18.3346 17.1142 17.1142C18.3346 15.8939 18.3346 13.9296 18.3346 10.0013C18.3346 6.07293 18.3346 4.10874 17.1142 2.88836C15.8939 1.66797 13.9296 1.66797 10.0013 1.66797C6.07293 1.66797 4.10874 1.66797 2.88836 2.88836ZM8.78722 6.26567C9.0253 6.01572 9.01563 5.6201 8.76563 5.38205C8.51572 5.14399 8.1201 5.15364 7.88205 5.4036L5.95368 7.42838L5.45388 6.9036C5.21583 6.65364 4.82023 6.64399 4.57027 6.88205C4.32031 7.1201 4.31066 7.51571 4.54872 7.76567L5.5011 8.76563C5.61906 8.88955 5.78263 8.95963 5.95368 8.95963C6.12473 8.95963 6.2883 8.88955 6.40627 8.76563L8.78722 6.26567ZM10.8346 6.8763C10.4895 6.8763 10.2096 7.15613 10.2096 7.5013C10.2096 7.84648 10.4895 8.1263 10.8346 8.1263H15.0013C15.3465 8.1263 15.6263 7.84648 15.6263 7.5013C15.6263 7.15613 15.3465 6.8763 15.0013 6.8763H10.8346ZM8.78722 12.099C9.0253 11.8491 9.01563 11.4535 8.76563 11.2154C8.51572 10.9773 8.1201 10.987 7.88205 11.237L5.95368 13.2617L5.45388 12.737C5.21583 12.487 4.82023 12.4773 4.57027 12.7154C4.32031 12.9535 4.31066 13.349 4.54872 13.599L5.5011 14.599C5.61906 14.7229 5.78263 14.793 5.95368 14.793C6.12473 14.793 6.2883 14.7229 6.40627 14.599L8.78722 12.099ZM10.8346 12.7096C10.4895 12.7096 10.2096 12.9895 10.2096 13.3346C10.2096 13.6798 10.4895 13.9596 10.8346 13.9596H15.0013C15.3465 13.9596 15.6263 13.6798 15.6263 13.3346C15.6263 12.9895 15.3465 12.7096 15.0013 12.7096H10.8346Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AssessmentsListIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>